import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

// Environments
import { environment } from "src/environments/environment";

// Modules
import { AppModule } from "src/app/app.module";

import { defineCustomElements } from "livespins.stencil/loader";

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

defineCustomElements(window);
